// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
const $Availability = tag => ({tag});
const Available = /* #__PURE__ */ $Availability("Available");
const TemporarilyUnavailable = /* #__PURE__ */ $Availability("TemporarilyUnavailable");
const Hidden = /* #__PURE__ */ $Availability("Hidden");
const eqAvailability = {
  eq: x => y => {
    if (x.tag === "Available") { return y.tag === "Available"; }
    if (x.tag === "TemporarilyUnavailable") { return y.tag === "TemporarilyUnavailable"; }
    if (x.tag === "Hidden") { return y.tag === "Hidden"; }
    return false;
  }
};
const ordAvailability = {
  compare: x => y => {
    if (x.tag === "Available") {
      if (y.tag === "Available") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "Available") { return Data$dOrdering.GT; }
    if (x.tag === "TemporarilyUnavailable") {
      if (y.tag === "TemporarilyUnavailable") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "TemporarilyUnavailable") { return Data$dOrdering.GT; }
    if (x.tag === "Hidden") {
      if (y.tag === "Hidden") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqAvailability
};
const genericAvailability = {
  to: x => {
    if (x.tag === "Inl") { return Available; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return TemporarilyUnavailable; }
      if (x._1.tag === "Inr") { return Hidden; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Available") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "TemporarilyUnavailable") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "Hidden") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)); }
    $runtime.fail();
  }
};
const showAvailability = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Available"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "TemporarilyUnavailable"});
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Hidden"});
    return x => {
      const $3 = genericAvailability.from(x);
      if ($3.tag === "Inl") { return $0["genericShow'"]($3._1); }
      if ($3.tag === "Inr") {
        if ($3._1.tag === "Inl") { return $1["genericShow'"]($3._1._1); }
        if ($3._1.tag === "Inr") { return $2["genericShow'"]($3._1._1); }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeAvailability = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericAvailability)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Available"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("TemporarilyUnavailable"), Data$dGeneric$dRep.NoArguments)]
  })({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("Hidden"), Data$dGeneric$dRep.NoArguments)]})))(Unscramble$dEnum.defaultEnumOptions)
};
const boundedAvailability = /* #__PURE__ */ (() => (
  {
    top: genericAvailability.to(Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))),
    bottom: genericAvailability.to(Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)),
    Ord0: () => ordAvailability
  }
))();
const enumAvailability = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericAvailability)(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({"genericBottom'": Data$dGeneric$dRep.NoArguments}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  })),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericAvailability)(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({
    "genericTop'": Data$dGeneric$dRep.NoArguments
  })(/* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments))({"genericBottom'": Data$dGeneric$dRep.NoArguments}))({
    "genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)
  })),
  Ord0: () => ordAvailability
};
const boundedEnumAvailability = /* #__PURE__ */ (() => (
  {
    cardinality: Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments)))[
      "genericCardinality'"
    ],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericAvailability)(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments)))),
    fromEnum: (() => {
      const $0 = Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumSum(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments))(Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments)));
      return x => $0["genericFromEnum'"](genericAvailability.from(x));
    })(),
    Bounded0: () => boundedAvailability,
    Enum1: () => enumAvailability
  }
))();
const encodeAvailability = {
  encode: x => {
    const $0 = genericAvailability.from(x);
    if ($0.tag === "Inl") { return "Available"; }
    if ($0.tag === "Inr") {
      if ($0._1.tag === "Inl") { return "TemporarilyUnavailable"; }
      if ($0._1.tag === "Inr") { return "Hidden"; }
      $runtime.fail();
    }
    $runtime.fail();
  }
};
const decodeAvailability = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericAvailability)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "Available"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({
    reflectSymbol: () => "TemporarilyUnavailable"
  }))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum({reflectSymbol: () => "Hidden"}))))
};
export {
  $Availability,
  Available,
  Hidden,
  TemporarilyUnavailable,
  boundedAvailability,
  boundedEnumAvailability,
  decodeAvailability,
  encodeAvailability,
  enumAvailability,
  eqAvailability,
  genericAvailability,
  ordAvailability,
  showAvailability,
  unscrambleDecodeAvailability
};
